import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import "./ConfirmationWithRejectReason.css";
import { TextField } from "@mui/material";
import { AssociationStatusEnum } from "../Modal/AssociationStatusEnum";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 616,
  bgcolor: "#FFFFFF",
  boxShadow: 24,
  p: 4,
};

function ConfirmationWithRejectReason(props) {
  const {
    showReason,
    options,
    actionName,
    rejectReasonId,
    additionalDetails,
    open,
    handleClose,
    title,
    description,
    isAssociationReq,
    isReadOnlyReason,
    onCancel,
    cancelButtonLabel,
    onConfirm,
    confirmButtonLabel,
  } = props;

  const [reason, setReason] = useState(rejectReasonId ?? 0);
  const [extraDetails, setExtraDetails] = useState(additionalDetails ?? "");

  useEffect(() => {
    setExtraDetails(additionalDetails ?? "");
    setReason(rejectReasonId ?? 0);
  }, [additionalDetails, rejectReasonId]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="confirmation-with-reason"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" sx={{ mb: 2 }}>
          {title}
        </Typography>

        {description && (
          <Typography id="modal-modal-description" sx={{ mb: 2, mt: 2 }}>
            {description}
          </Typography>
        )}

        <div className="close-icon-position">
          <CloseOutlinedIcon
            data-testid="CloseNewAdminPopup"
            onClick={handleClose}
            style={{ cursor: "pointer" }}
          />
        </div>

        {showReason && (
          <>
            {!isAssociationReq && (
              <div className="reason-div mt-2">
                <select
                  id="previewType"
                  name="previewType"
                  data-testid="preview-type"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  disabled={isReadOnlyReason}
                  className="form-label form-control input-border custom-sel-ect cus-cus-avl additionalDetails"
                  style={{ width: "100%", color: "black" }}
                >
                  {actionName === AssociationStatusEnum.Rejected && (
                    <option>Select Reject Reason</option>
                  )}
                  {actionName === AssociationStatusEnum.Approved && (
                    <option>Select Role</option>
                  )}
                  {options?.map((res) => (
                    <option key={res.value} value={res.value}>
                      {res.name}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {actionName === AssociationStatusEnum.Rejected && (
              <div className="reason-div mt-2">
                <TextField
                  multiline
                  value={extraDetails}
                  className="reason-div-textfield additionalDetails"
                  data-testid="reason_textbox"
                  rows={8}
                  onChange={(e) => setExtraDetails(e.target.value)}
                  style={{ width: "100%", color: "black", border: "none" }}
                  disabled={isReadOnlyReason}
                />
              </div>
            )}
          </>
        )}

        {!isReadOnlyReason && (
          <div className="action-btn-div mt-4">
            <Button
              className="action-button"
              variant="outlined"
              onClick={(e) => {
                setReason(0);
                setExtraDetails("");
                onCancel(e);
              }}
              data-testid="cancel-action"
            >
              {cancelButtonLabel}
            </Button>
            <Button
              className="action-button ml-4"
              variant="contained"
              onClick={(e) => {
                setReason(0);
                setExtraDetails("");
                onConfirm(e, reason, extraDetails);
              }}
              data-testid="confirm-action"
              disabled={reason === "" || extraDetails === ""}
            >
              {confirmButtonLabel}
            </Button>
          </div>
        )}
      </Box>
    </Modal>
  );
}

// ✅ Add PropTypes validation
ConfirmationWithRejectReason.propTypes = {
  actionName: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  showReason: PropTypes.bool,
  rejectReasonId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  additionalDetails: PropTypes.string,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  isAssociationReq: PropTypes.bool,
  isReadOnlyReason: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  cancelButtonLabel: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  confirmButtonLabel: PropTypes.string,
};

// ✅ Default props for optional values
ConfirmationWithRejectReason.defaultProps = {
  showReason: false,
  options: [],
  rejectReasonId: 0,
  additionalDetails: "",
  description: "",
  isAssociationReq: false,
  isReadOnlyReason: false,
  cancelButtonLabel: "Cancel",
  confirmButtonLabel: "Confirm",
};

export default ConfirmationWithRejectReason;
